document.documentElement.classList.remove("no-js");

document.addEventListener("DOMContentLoaded", () => {
  const searchPanel = document.querySelector("[data-search-panel]");
  const searchToggle = document.querySelector("[data-search-toggle]");
  const searchClose = document.querySelector("[data-search-close]");
  const menu = document.querySelector("[data-mobile-drawer]");
  const menuOpen = document.querySelector("[data-menu-open]");
  const menuClose = document.querySelector("[data-menu-close]");
  const backdrop = document.querySelector("[data-drawer-backdrop]");

  const closeMenu = () => {
    if (!menu || !backdrop) return;
    menu.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    menu.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open");
  };

  searchToggle?.addEventListener("click", () => {
    const willOpen = searchPanel?.hasAttribute("hidden");
    if (willOpen) {
      searchPanel?.removeAttribute("hidden");
      searchToggle.setAttribute("aria-expanded", "true");
      searchPanel?.querySelector("input")?.focus();
    } else {
      searchPanel?.setAttribute("hidden", "");
      searchToggle.setAttribute("aria-expanded", "false");
    }
  });

  searchClose?.addEventListener("click", () => {
    searchPanel?.setAttribute("hidden", "");
    searchToggle?.setAttribute("aria-expanded", "false");
    searchToggle?.focus();
  });

  menuOpen?.addEventListener("click", () => {
    menu?.classList.add("is-open");
    backdrop?.classList.add("is-open");
    menu?.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open");
  });

  menuClose?.addEventListener("click", closeMenu);
  backdrop?.addEventListener("click", closeMenu);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
      if (searchPanel && !searchPanel.hasAttribute("hidden")) {
        searchPanel.setAttribute("hidden", "");
        searchToggle?.setAttribute("aria-expanded", "false");
      }
    }
  });
});
